<div class="st-full-screen-dialog">
    <div class="st-full-screen-dialog__header">
        @if (record() && !record()?.isNewRecord) {
            <button
                class="st-full-screen-dialog__header__top-row__home-button"
                mat-icon-button
                (click)="openHomeItem()">
                <mat-icon svgIcon="home" />
            </button>
            <button
                class="st-full-screen-dialog__header__top-row__pin-item__button"
                mat-icon-button
                [matTooltip]="languageSettings().PSTWebPinItemButtonLabel"
                [matMenuTriggerFor]="pinItemMenu"
                (menuOpened)="onPinItemMenuOpened()">
                <mat-icon> add </mat-icon>
            </button>
            <mat-menu
                #pinItemMenu="matMenu"
                class="st-full-screen-dialog__header__top-row__pin-item__menu"
                st-click-stop-propagation>
                <st-simple-search-box
                    st-click-stop-propagation
                    class="st-full-screen-dialog__header__top-row__pin-item__menu-seach-box"
                    [searchTherm]="pinItemsSearchTerm()"
                    (searchThermChange)="searchItemExecute($event)" />
                <st-accordion class="st-full-screen-dialog__header__top-row__pin-item__menu__item-view__accordion">
                    <cdk-virtual-scroll-viewport
                        class="st-full-screen-dialog__header__top-row__pin-item__menu__item-view__view-port"
                        st-different-sizes
                        cdkScrollable
                        [itemHeights]="cardItemHeights$ | ngrxPush">
                        <ng-container *cdkVirtualFor="let node of treeDataSource$ | ngrxPush; let isLast = last; let idx = index; trackBy: trackByGuid; templateCacheSize: 0">
                            <ng-container [ngSwitch]="node?.level">
                                <ng-template [ngSwitchCase]="0">
                                    <st-expansion-panel
                                        *ngrxLet="selectTreeControl$ as treeControl"
                                        st-click-stop-propagation
                                        class="st-full-screen-dialog__header__top-row__pin-item__menu__item-view__pane-container"
                                        [guid]="'GROUP_' + node.id"
                                        [expanded]="treeControl.isExpanded(node)"
                                        (click)="toggleNode(treeControl, node)">
                                        <span title>{{ node.label }}</span>
                                    </st-expansion-panel>
                                </ng-template>
                                <ng-template ngSwitchDefault>
                                    <div
                                        mat-menu-item
                                        class="st-full-screen-dialog__header__top-row__pin-item__menu__item-view__item"
                                        (click)="pinItem(node.object.Guid)">
                                        <div class="st-full-screen-dialog__header__top-row__pin-item__menu__item-view__item__label">
                                            {{ node.object.Title }}
                                        </div>
                                    </div>
                                </ng-template>
                            </ng-container>
                        </ng-container>
                    </cdk-virtual-scroll-viewport>
                </st-accordion>
            </mat-menu>
            <div class="st-full-screen-dialog__header__top-row__pinned-items">
                <div class="st-full-screen-dialog__header__top-row__pinned-items__container">
                    @for (item of topbarItems(); track item?.Guid; let idx = $index) {
                        @if (!noBorderIndexes().includes(idx)) {
                            <div class="st-full-screen-dialog__header__top-row__pinned-items__item__separator"></div>
                        }
                        <div
                            st-click-stop-propagation
                            class="st-full-screen-dialog__header__top-row__pinned-items__item"
                            [class.st-full-screen-dialog__header__top-row__pinned-items__item--selected]="selectedPinItemGuid() === item?.Guid"
                            [matTooltip]="item?.Title"
                            (mouseenter)="hoverItem(item.Guid)"
                            (mouseleave)="hoverItem('')"
                            (click)="onPinnedItemChanged(item?.Guid, item?.Type)">
                            <st-record-mat-icon
                                [recordType]="item.Type"
                                [subType]="item.Type === ObjectTypesEnum.SCRIPT ? item[PSTFieldNames.PSTStoryOutputType] : null" />
                            <div class="st-full-screen-dialog__header__top-row__pinned-items__item__content__label">
                                {{ item?.Title }}
                            </div>
                            @if (hoveredItemGuid() === item.Guid) {
                                <button
                                    class="st-full-screen-dialog__header__top-row__pinned-items__item__close__button"
                                    st-click-stop-propagation
                                    mat-icon-button
                                    (click)="unpinItem(item?.Guid)">
                                    <mat-icon> close </mat-icon>
                                </button>
                            }
                        </div>
                    }
                </div>
                @if (topbarItems().length > 1) {
                    <button
                        mat-icon-button
                        st-click-stop-propagation
                        [matMenuTriggerFor]="allItemsMenu">
                        <mat-icon>more_horiz</mat-icon>
                    </button>
                    <mat-menu
                        #allItemsMenu="matMenu"
                        class="st-full-screen-dialog__header__top-row__pinned-items__all-items-menu"
                        st-click-stop-propagation>
                        <st-simple-search-box
                            st-click-stop-propagation
                            [searchTherm]="pinnedItemsSerachTerm()"
                            (searchThermChange)="searchPinnedItemExecute($event)" />
                        <div class="st-full-screen-dialog__header__top-row__pinned-items__all-items-menu__container">
                            @for (item of filteredPinnedItems(); track item.Guid; let idx = $index) {
                                <div
                                    class="st-full-screen-dialog__header__top-row__pinned-items__all-items-menu__item"
                                    [matTooltip]="item?.Title"
                                    (click)="selectItem(item?.Guid, item.Type)">
                                    <st-record-mat-icon
                                        [recordType]="item.Type"
                                        [subType]="item.Type === ObjectTypesEnum.SCRIPT ? item[PSTFieldNames.PSTStoryOutputType] : null" />
                                    <div class="st-full-screen-dialog__header__top-row__pinned-items__all-items-menu__item__content__label">
                                        {{ item?.Title }}
                                    </div>
                                    <button
                                        class="st-full-screen-dialog__header__top-row__pinned-items__all-items-menu__item__close__button"
                                        st-click-stop-propagation
                                        mat-icon-button
                                        (click)="unpinItem(item?.Guid)">
                                        <mat-icon> close </mat-icon>
                                    </button>
                                </div>
                            }
                        </div>
                    </mat-menu>
                }
            </div>
        }
        <div class="st-full-screen-dialog__header__top-row__template-switcher">
            <mat-button-toggle-group
                class="st-full-screen-dialog__header__top-row__template-switcher__group"
                hideSingleSelectionIndicator
                (change)="onTemplateChanged($event)">
                @for (item of templateItems; track item; let idx = $index) {
                    <mat-button-toggle
                        aria-label="Text align left"
                        [checked]="selectedTemplate() === item"
                        [value]="item"
                        [attr.tabindex]="0">
                        <mat-icon [svgIcon]="'template_selection_' + (idx + 1)" />
                    </mat-button-toggle>
                }
            </mat-button-toggle-group>
        </div>
        <button
            class="st-topic-full-screen-header-close-button"
            mat-icon-button
            [matTooltip]="languageSettings().PSTWebCloseButtonLabel"
            (click)="closeModal()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div
        class="st-full-screen-dialog__content"
        [ngClass]="templateLayoutClass$ | ngrxPush">
        <div class="st-full-screen-dialog__content--item st-full-screen-dialog__content--item--main">
            <div
                class="st-full-screen-dialog__content--item--main--border-left"
                st-left-border
                [data]="record()"></div>
            <div class="st-full-screen-dialog__content--item--main--items">
                @switch (record()?.Type) {
                    @case (ObjectTypesEnum.RUNDOWN) {
                        <st-rundown-full-screen
                            [data]="record()"
                            (onStoryOpen)="openRoStory($event)" />
                    }
                    @case (ObjectTypesEnum.SCRIPT) {
                        <st-stories-full-screen />
                    }
                    @case (ObjectTypesEnum.TOPIC) {
                        <st-topic-full-screen
                            [data]="topicData()"
                            (assignmentOpen)="onAssignmentOpenHandler($event)"
                            (storyOpen)="onStoryOpenHandler($event)" />
                    }
                }

                @if (!isCreate() && !selectedPinItemGuid()) {
                    <div class="st-full-screen-dialog__content__main__footer">
                        <div class="st-full-screen-dialog__content__main__footer__navigation">
                            <button
                                mat-icon-button
                                class="st-full-screen-dialog__content__main__footer__navigation__btnFirst"
                                (click)="navigate($event, NavigationDirection.FIRST)">
                                <mat-icon>first_page</mat-icon>
                            </button>
                            <button
                                mat-icon-button
                                class="st-full-screen-dialog__content__main__footer__navigation__btnPrevious"
                                (click)="navigate($event, NavigationDirection.PREVIOUS)">
                                <mat-icon>navigate_before</mat-icon>
                            </button>
                            <button
                                mat-button
                                class="st-full-screen-dialog__content__main__footer__navigation__text"
                                [mat-menu-trigger-for]="listDropDownMenu"
                                (click)="onMenuOpened()">
                                {{ recordType() }} {{ currentIdx() }} of {{ totalCount() }}
                            </button>
                            <mat-menu
                                #listDropDownMenu="matMenu"
                                yPosition="above"
                                class="st-full-screen-dialog__content__main__footer__navigation__menu">
                                <mat-form-field
                                    class="st-full-screen-dialog__content__main__footer__navigation__menu__search-box"
                                    st-click-stop-propagation
                                    subscriptSizing="dynamic"
                                    appearance="fill">
                                    <mat-icon matPrefix>search</mat-icon>
                                    <input
                                        #searchBox
                                        type="text"
                                        matInput
                                        [value]="searchInput()"
                                        (input)="onSearchInputChange($event)" />
                                    <mat-icon
                                        matSuffix
                                        (click)="clearSearch($event)"
                                        >close</mat-icon
                                    >
                                </mat-form-field>
                                <mat-selection-list
                                    hideSingleSelectionIndicator
                                    multiple="false"
                                    [ngModel]="currentMenuItem() ? [currentMenuItem()] : []">
                                    @for (item of matMenuSearchOptions(); track item?.uniqueId) {
                                        <mat-list-option
                                            class="st-full-screen-dialog__content__main__footer__navigation__menu__option"
                                            [matTooltip]="item.tooltip"
                                            [value]="item"
                                            (click)="navigateDirectly(item?.uniqueId)">
                                            <div class="st-full-screen-dialog__content__main__footer__navigation__menu__option__content">
                                                <div
                                                    st-left-border
                                                    class="st-full-screen-dialog__content__main__footer__navigation__menu__option__icon__story"
                                                    [data]="item?.object"></div>
                                                <div class="st-full-screen-dialog__content__main__footer__navigation__menu__option__content__label">
                                                    <div class="st-full-screen-dialog__content__main__footer__navigation__menu__option__content__label__title">
                                                        {{ item?.object?.Title }}
                                                    </div>
                                                    @if (item.object.ContainerTitle) {
                                                        <span class="st-full-screen-dialog__content__main__footer__navigation__menu__option__content__label__rundown">
                                                            [{{ item.object.ContainerTitle }}
                                                        </span>
                                                        <span>{{ item.containerModTimeDate }}]</span>
                                                    }
                                                </div>
                                                <mat-icon class="st-full-screen-dialog__content__main__footer__navigation__menu__option__icon__check">check</mat-icon>
                                            </div>
                                        </mat-list-option>
                                    }
                                </mat-selection-list>
                                <span class="st-full-screen-dialog__content__main__footer__navigation__menu__total-results">{{
                                    matMenuSearchOptions()?.length + ' ' + languageSettings()[PSTWebTotalResultsLabel]
                                }}</span>
                            </mat-menu>
                            <button
                                mat-icon-button
                                class="st-full-screen-dialog__content__main__footer__navigation__btnNext"
                                (click)="navigate($event, NavigationDirection.NEXT)">
                                <mat-icon>navigate_next</mat-icon>
                            </button>
                            <button
                                mat-icon-button
                                class="st-full-screen-dialog__content__main__footer__navigation__btnLast"
                                (click)="navigate($event, NavigationDirection.LAST)">
                                <mat-icon>last_page</mat-icon>
                            </button>
                        </div>
                    </div>
                }
            </div>
        </div>

        @if (sidecartMainVisible$ | ngrxPush) {
            <div class="st-full-screen-dialog__content--item st-full-screen-dialog__content--item--sidecar-main">
                <st-sidecar-full-screen [type]="FullscreenSidecar.SIDECAR_MAIN" />
            </div>
        }
        @if (sidecartSecondVisible$ | ngrxPush) {
            <div class="st-full-screen-dialog__content--item st-full-screen-dialog__content--item--sidecar-second">
                <st-sidecar-full-screen [type]="FullscreenSidecar.SIDECAR_SECOND" />
            </div>
        }
        @if (sidecartThirdVisible$ | ngrxPush) {
            <div class="st-full-screen-dialog__content--item st-full-screen-dialog__content--item--sidecar-third">
                <st-sidecar-full-screen [type]="FullscreenSidecar.SIDECAR_THIRD" />
            </div>
        }
        @if (sidecartFourthVisible$ | ngrxPush) {
            <div class="st-full-screen-dialog__content--item st-full-screen-dialog__content--item--sidecar-fourth">
                <st-sidecar-full-screen [type]="FullscreenSidecar.SIDECAR_FOURTH" />
            </div>
        }
    </div>
</div>
